import { SaveReceiption } from '../Adapters/SaveReceiption';

export const add_reception = (
  data,
  setEnableLoading,
  navigate
) => {
  SaveReceiption(data, setEnableLoading, navigate);
};
